"use strict";function beaconPicker$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.beaconPicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ATMBle.beaconPicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.0.7"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.0.7"},_a)),exports.beaconPicker$=beaconPicker$,exports.default=beaconPicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ATMBle/beaconPicker.js
// module id = 900
// module chunks = 106